@if (allowToClose()) {
  <div class="close-wrapper">
    <button type="button" class="secondary" alg-button-icon icon="ph ph-x" (click)="closeEvent.emit()"></button>
  </div>
}

@if (showIcon()) {
  <div class="icon-wrapper">
    <span class="{{ icon() }} {{ iconStyleClass() || '' }} icon"></span>
  </div>
}

@if (modalTitle(); as title) {
  <div class="title alg-h4">{{ title }}</div>
}

<div class="body">
  <ng-content></ng-content>
</div>
